import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {SeriesSimpleVo} from '../../common/shared/api/nicolas/vo/SeriesSimpleVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';

/**
 * 콘텐츠 단일 회차 기본 정보 조회
 *
 * Origin: pageNicolasApi.getContentSeriesSimple
 * API: GET /api/v1/content/series/simple
 */
export async function getContentSeriesSimple(
  {
    seriesId,
    productId,
  }: {
    seriesId: number;
    productId?: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: SeriesSimpleVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/series/simple',
    {
      method: 'GET',
      params: trimUndefinedFromObject({
        series_id: seriesId,
        product_id: productId,
      }),
    },
    options
  );

  return response.data;
}
